import {
  UPDATE_ACTION_TYPE,
  UPDATE_COUPON_STATUS,
  UPDATE_COUPON_LIST,
  UPDATE_CLUB_TABLE_LIST,
} from './constants'
import { Message } from 'antd'
import { postData } from '../../util'
import { API_DOMAIN } from '../../config'
import { fetchCouponList, disableCoupon } from '../../api/cardManage'

export const getCouponListData = () => async (dispatch, getState) => {
  const clubId = sessionStorage.getItem('club_id')
  const { couponStatus } = getState().getCardManage
  const { status, detail, data } = await fetchCouponList({
    type: couponStatus,
    isShare: true,
    clubId: clubId,
  })
  if (status != 1) {
    Message.error(detail)
    return
  }
  const array = [].concat(data)
  if (array.length > 0) {
    const newArray = array.map((item) => {
      const { coupon } = item
      return {
        ...item,
        coupon: {
          ...coupon,
          amount: coupon.amount / 100,
          limitDuration: coupon.limitDuration / 60,
          isTableLimit: !coupon.isTableLimit,
        },
      }
    })
    dispatch(updateCouponList(newArray.reverse()))
  } else {
    dispatch(updateCouponList([]))
  }
  return data
}

// 获取俱乐部中的球台列表
export const fetchClubTableList = () => async (dispatch, getState) => {
  const clubId = sessionStorage.getItem('club_id')
  const endpoint = `${API_DOMAIN}/CouponApi/TableIng`
  return postData(endpoint, 'POST', JSON.stringify({ club_id: clubId }))
    .then((data) => {
      console.log('获取对应俱乐部的球台列表:', data)
      const list = data.list
      if (list && Array.isArray(list) && list.length > 0) {
        dispatch(updateClubTableList(list))
      } else {
        dispatch(updateClubTableList([]))
      }
    })
    .catch((e) => {
      dispatch(updateClubTableList([]))
    })
}

// 删除卡券
export const deleteCoupon = (params) => async (dispatch, getState) => {
  const { status, detail } = await disableCoupon({ id: params.coupon.id })
  if (status != 1) {
    Message.error(detail)
    return
  }
  dispatch(getCouponListData())
}

export const updateCouponStatus = (payload) => {
  return {
    type: UPDATE_COUPON_STATUS,
    payload,
  }
}
export const updateCouponList = (payload) => {
  return {
    type: UPDATE_COUPON_LIST,
    payload,
  }
}
export const updateActionType = (payload) => {
  return {
    type: UPDATE_ACTION_TYPE,
    payload,
  }
}
export const updateClubTableList = (payload) => {
  return {
    type: UPDATE_CLUB_TABLE_LIST,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/containers/CardManage/action.js